export { default } from './capitalize';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/capitalize/index.js
// module id = 133
// module chunks = 22